import { PropsWithChildren } from 'react';

import { Styles, css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';

interface HorizontalButtonGroupProps extends PropsWithChildren {
  css?: Styles;
}
const HorizontalButtonGroupBase = ({ children, css: cssProps }: HorizontalButtonGroupProps) => {
  return <div className={css(flex.raw({ gap: 4 }), cssProps)}>{children}</div>;
};

interface ButtonProps extends PropsWithChildren {
  onClick?: () => void;
}
const Button = ({ children, onClick }: ButtonProps) => {
  return (
    <button type='button' className={buttonStyle} onClick={onClick}>
      {children}
    </button>
  );
};

export const HorizontalButtonGroup = Object.assign(HorizontalButtonGroupBase, { Button });

const buttonStyle = css({
  position: 'relative',
  flex: '1 0',
  px: 10,
  py: 6,
  rounded: 8,
  textAlign: 'center',
  textStyle: 'Text/M/Monospace/Regular',
  color: 'content.default.level-5',
  bg: 'background.default.level-3',
  _focus: {
    _before: {
      content: '""',
      pos: 'absolute',
      inset: -2,
      rounded: 6,
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'content.accent.info',
    },
  },
});
